import React, { useState, useEffect, useRef } from 'react'
import { Button, Form } from 'semantic-ui-react'
import GoogleButton from 'react-google-button'
import useModal from 'hooks/useModal'
import * as R from 'ramda'
import { CrownBadge } from 'components/ProFeatureLabel'
import { TooltipLabelWithoutIcon } from 'components/TooltipLabelWithoutIcon'

export default function Oauth2WithPropertiesModal({
  authenticationSettings,
  connectorProperties,
  onActivate,
  loading,
  isAuthenticateSuccessful,
  allowPremiumIntegration,
  enableNewBillingPlan,
  isGoogleConnector,
}) {
  const { Modal, open, close } = useModal()
  const [fields, setFields] = useState([])
  const hiddenSubmitButtonRef = useRef(null)

  function handleSubmit(event) {
    event.preventDefault()
    const properties = R.filter((field) => field.type === 'properties', fields)
    onActivate({ properties })
  }

  function handleOnChange(index, value) {
    setFields((fields) => R.assocPath([index, 'value'], value, fields))
  }

  function handleTriggerSubmit() {
    if (R.prop('current', hiddenSubmitButtonRef)) {
      hiddenSubmitButtonRef.current.click()
    }
  }

  useEffect(() => {
    if (authenticationSettings) {
      connectorProperties.forEach(function (connector) {
        connector.type = 'properties'
      })
      setFields([...connectorProperties, ...authenticationSettings])
    }
  }, [connectorProperties, authenticationSettings])

  useEffect(() => {
    if (isAuthenticateSuccessful) {
      close()
    }
  }, [close, isAuthenticateSuccessful])

  return (
    <>
      {!enableNewBillingPlan || allowPremiumIntegration ? (
        isGoogleConnector ? (
          <div className="flex justify-end">
            <GoogleButton onClick={open} disabled={loading} />
          </div>
        ) : (
          <Button primary onClick={open}>
            Authenticate
          </Button>
        )
      ) : (
        <TooltipLabelWithoutIcon
          descriptionTitle={
            <span className="flex">
              Premium integrations <CrownBadge />
            </span>
          }
          descriptionContent="Premium integrations are available on a higher plan. Upgrade to unlock this feature."
          showGotoBillingPage={true}
          trigger={
            isGoogleConnector ? (
              <div className="flex justify-end">
                <GoogleButton disabled />
              </div>
            ) : (
              <div>
                <Button primary disabled className="cursor-pointer">
                  Authenticate
                </Button>
              </div>
            )
          }
          learnMoreLink={''}
        />
      )}

      <Modal size="small">
        <Modal.Header>Authenticate</Modal.Header>
        <Modal.Content>
          <Form onSubmit={handleSubmit}>
            {fields.map((field, index) => (
              <Form.Field key={field.name}>
                <label>{field.label}</label>
                <input
                  type="text"
                  name={field.name}
                  placeholder={field.placeholder}
                  onChange={(e) => handleOnChange(index, e.target.value)}
                  required
                />
              </Form.Field>
            ))}
            <input type="submit" hidden ref={hiddenSubmitButtonRef} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close}>Cancel</Button>
          <Button primary onClick={handleTriggerSubmit} loading={loading} disabled={loading}>
            Authenticate
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/CyclrIntegrationAuthenticationSegment/Oauth2WithPropertiesModal.tsx